import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M12 14.5585L17 18.12V5L7.00002 5L7 18.12L12 14.5585ZM12 17.014L17.4199 20.8745C18.0819 21.346 19 20.8727 19 20.06V4C19 3.44772 18.5523 3 18 3L6.00002 3C5.44774 3 5.00002 3.44772 5.00002 4L5 20.06C5 20.8727 5.91816 21.346 6.58016 20.8745L12 17.014Z" fill={ fill || 'currentColor' }/>
    </svg>
);
